import { Injectable } from '@angular/core';
import { Details } from '../../model/details';
import { AngularFireDatabase } from 'angularfire2/database';

@Injectable()
export class SellerService {
  
  constructor(private db: AngularFireDatabase) { }

  addNew(details:Details, sellerId ) { 
    return this.db.list('/seller-details/'+sellerId).push(details);
  }

  getSellerId(sellerId) {
    return this.db.list('/seller-details/' + sellerId);
  }

  update(details:Details, sellerId, key) { 
    return this.db.object('/seller-details/' + sellerId + '/' + key).update(details);
  }

  save(data, sellerId) {
    this.db.object('/seller-details/profiles/' + sellerId).update(data);
  }

  get(sellerId) { 
    return this.db.object('/seller-details/profiles/' + sellerId);
  }

  getUser(sellerId){
    return this.db.object('/users/' + sellerId);
  }

  getAllAgents() { 
    return this.db.list('/agent-details/profiles/');
  }

  getCommission() { 
    return this.db.object('/commission');
  }

}
